import {Injectable} from '@angular/core';
import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class DateTimeService {

  constructor() {
  }

  public timePickerValidator(defaultTime: any): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let notInitialized: boolean;
      if (defaultTime['second']) {
        notInitialized = DateTimeService.isHourMinuteAndSecondSet(control.value, defaultTime);
      } else {
        notInitialized = DateTimeService.isHourAndMinuteSet(control.value, defaultTime);
      }
      return notInitialized ? {initialized: {value: control.value}} : null;
    };
  }

  private static isHourMinuteAndSecondSet(inputTime: any, defaultTime: any): boolean {
    return (inputTime && (inputTime.hour === defaultTime.hour || inputTime.minute === defaultTime.minute || inputTime.second === defaultTime.second));
  }

  private static isHourAndMinuteSet(inputTime: any, defaultTime: any): boolean {
    return (inputTime && (inputTime.hour === defaultTime.hour || inputTime.minute === defaultTime.minute));
  }
}
